class InterestsDrawer extends Drawer { 
  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('interests-drawer:toggle', (e) => {
      if (e.detail.action === 'close') {
        this.handleCloseUpdateButton();
      }
    });
  }

  handleCloseUpdateButton() {
    const form = document.getElementById('custom-form-create_customer');
    if (!form) return;

    const formTags = form.querySelector('input[name="customer[tags]"]');
    if (!formTags) return;

    const value = formTags.value || '';

    const hasInterests = [
      'Audience:',
      'Style:',
      'Headwear Fit:',
      'Product Type:',
      'Team:'
    ].some(tag => value.includes(tag));

    const triggerButton = form.querySelector('interests-button');
    if (!triggerButton) return;

    if (hasInterests) {
      triggerButton.querySelector(".interests-button__text").textContent = triggerButton.dataset.editPreferencesText;
    } else {
      triggerButton.querySelector(".interests-button__text").textContent = triggerButton.dataset.inputName;
    }
  }
}
customElements.define('interests-drawer', InterestsDrawer);

class InterestsDrawerButton extends DrawerButton {
  handleClick() {
    this.toggleDrawer();
  }
}
customElements.define('interests-button', InterestsDrawerButton);